<template>
  <tr>
    <template v-if="$vuetify.display.mdAndUp">
      <td colspan="99" class="pa-0">
        <v-card color="strong py-4 px-8">
          <v-row dense>
            <v-col cols="1">
              <div class="expanded-title mb-1">
                {{
                  $t(
                    "people:PersonProfile.CompetitionResultsSection.Competition.label",
                    "Class"
                  )
                }}
              </div>
              {{ item.competition.code }}
            </v-col>
            <v-col cols="4">
              <div class="expanded-title mb-1">
                {{
                  $t(
                    "people:PersonProfile.CompetitionResultsSection.CompetitionRule.label",
                    "Competition rule"
                  )
                }}
              </div>
              <AppShowDifficultyLevel :competition="item.competition" />
              <div>{{ get(item, "competitionRule.name") }}</div>
            </v-col>
            <v-col>
              <div class="expanded-title mb-1">
                {{
                  $t(
                    "people:PersonProfile.CompetitionResultsSection.Cup.label",
                    "Cup"
                  )
                }}
              </div>

              <AppShowCupSeasons
                v-if="
                  item.competition.cupSeasons &&
                  item.competition.cupSeasons.length > 0
                "
                :cup-seasons="item.competition.cupSeasons"
                class="text-secondary"
                variant="text"
              />

              <div>
                <AppShowCompetitionGrandPrix :competition="item.competition" />
              </div>
            </v-col>
            <v-col>
              <div class="expanded-title mb-1">
                {{
                  $t(
                    "people:PersonProfile.CompetitionResultsSection.EventCode.label",
                    "Event code"
                  )
                }}
              </div>
              <AppShowEventcode
                v-if="item.competition.eventcodeId"
                :competition="item.competition"
              />
            </v-col>
            <v-col md="2">
              <div class="expanded-title mb-1">
                {{
                  $t(
                    "people:PersonProfile.CompetitionResultsSection.Location.label",
                    "Location"
                  )
                }}
              </div>
              <AppShowCountry
                v-if="get(item.competition, 'event.country', false)"
                :country="item.competition.event.country"
              />
              {{ get(item.competition, "event.region.name") }}
            </v-col>
          </v-row>

          <v-divider class="my-3 muted" />

          <v-row justify="center">
            <v-col cols="12" md="3">
              <div v-if="item.competition.event.discipline.name == 'driving'">
                <div>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.Grooms.label",
                      "Groom(s)"
                    )
                  }}: <AppShowDrivingGrooms :registration="item.registration" />
                </div>
                <div>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.CarriageNr.label",
                      "Carriage nr"
                    )
                  }}: {{ item.registration.carriageNumber }}
                </div>
                <div v-if="item.registration.drivingCarriageWidth">
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.CarriageWidth.label",
                      "Carriage width"
                    )
                  }}:
                  {{ item.registration.drivingCarriageWidth }}
                </div>
              </div>
              <div
                v-else-if="item.competition.event.discipline.name == 'vaulting'"
              >
                <div>
                  <b>
                    {{
                      $t(
                        "people:PersonProfile.CompetitionResultsSection.Team.label",
                        "Team"
                      )
                    }}
                  </b>
                  : {{ item.registration.teamName }}
                </div>
                <br />
                <v-row no-gutters>
                  <v-col>
                    <b>
                      {{
                        $t(
                          "people:PersonProfile.CompetitionResultsSection.Athletes.label",
                          "Athletes"
                        )
                      }}
                    </b>
                    <AppShowPeopleList
                      :people="item.registration.athletes"
                      show-name-with-identifiers
                    />
                  </v-col>
                  <v-col v-if="item.registration.vaultingLungerPerson">
                    <b>
                      {{
                        $t(
                          "people:PersonProfile.CompetitionResultsSection.Lunger.label",
                          "Lunger"
                        )
                      }}
                    </b>
                    <AppShowPeopleList
                      :people="[item.registration.vaultingLungerPerson]"
                      show-name-only
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <template v-if="resultsIsVisible">
                <div
                  v-if="showLongResults"
                  class="bg-white competition-results pa-4"
                >
                  <AppShowLongResults
                    :result="item"
                    :discipline-name="item.competition.event.discipline.name"
                    :competition="item.competition"
                  />
                </div>
              </template>
            </v-col>
            <v-col cols="12" md="3" class="award-prize">
              <ul class="my-3" style="padding-left: 0; list-style: none">
                <li v-for="point in displayPoints(item)" :key="point.id">
                  {{ get(point.chartRule, "chart.name", "?") }}:
                  {{ point.finalValue }}
                </li>
              </ul>

              <div
                v-if="
                  get(profilePerson, 'personClubRegion.name') &&
                  item.competition.event.discipline.name != 'vaulting'
                "
              >
                {{ $t("common:common.results.clubRegion.column") }}<br />
                <AppShowOrganisationName
                  :organisation="profilePerson.personClubOrganisationId"
                />
                <br />
                {{ get(profilePerson, "personClubRegion.name") }}
              </div>

              <div v-if="activeRegistrationQualification">
                <div class="mt-5">
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.qualifyingResult.text"
                    )
                  }}<template v-if="item.satisfiesQualification">
                    <span :aria-label="$t('common:yes.label')"
                      ><v-icon color="green" size="small" class="ml-2"
                        >$iconCheck</v-icon
                      ></span
                    > </template
                  ><template v-else> - </template>
                </div>
                <div v-if="item.unqualifiesQualification" class="mt-2">
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.unqualifyingResult.text"
                    )
                  }}
                  <UnqualifiedBadge />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </td>
    </template>
    <template v-else>
      <td colspan="99" class="pa-0">
        <v-card color="strong pa-4">
          <div>
            <div style="font-size: 14px !important">
              {{ $dayjs.date(item.competition.startDate) }}
            </div>
            <div style="font-size: 14px !important">
              <AppShowCountry
                v-if="get(item.competition, 'event.country', false)"
                :country="item.competition.event.country"
              />
              {{ get(item.competition, "event.region.name") }}
            </div>
          </div>
          <br />
          <div>
            <v-row v-if="profile == 'person'" no-gutters class="mb-4">
              <v-col cols="5">
                <b>
                  {{
                    $t(
                      "events:common.results.horse.column",
                      "Horse",
                      "Label for horse column in results"
                    )
                  }}
                </b>
              </v-col>
              <v-col class="text-right" cols="7">
                <AppShowRegistrationHorses
                  component-name="AppShowHorseName"
                  :horses="item.registration.horses"
                  :registration-horses="item.registration.registrationHorses"
                  :component-props="{ showIdentifier: true }"
                />
              </v-col>
            </v-row>

            <v-row v-if="profile == 'horse'" no-gutters class="mb-4">
              <v-col cols="5">
                <b>
                  {{
                    $t(
                      "events:common.results.athlete.column",
                      "Athlete",
                      "Label for athlete column in results"
                    )
                  }}
                </b>
              </v-col>
              <v-col class="text-right" cols="7">
                <AppShowPeopleList
                  :people="[item.registration.athletes[0]]"
                  show-name-with-identifiers
                />
              </v-col>
            </v-row>

            <v-row no-gutters class="mb-4">
              <v-col cols="5">
                <b>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.Competition.label",
                      "Class"
                    )
                  }}
                </b>
              </v-col>
              <v-col class="text-right" cols="7">
                {{ item.competition.code }}
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-4">
              <v-col cols="5">
                <b>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.CompetitionRule.label",
                      "Competition rule"
                    )
                  }}
                </b>
              </v-col>
              <v-col class="text-right" cols="7">
                <AppShowDifficultyLevel :competition="item.competition">
                  <template #append>
                    <span v-if="item.sectionId">
                      (<AppShowSection :section="item.section" />)
                    </span>
                  </template>
                </AppShowDifficultyLevel>
                <div>{{ get(item, "competitionRule.name") }}</div>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-4">
              <v-col cols="5">
                <b>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.EventCode.label",
                      "Event code"
                    )
                  }}</b
                >
              </v-col>
              <v-col class="text-right text-secondary" cols="7">
                <AppShowEventcode
                  v-if="item.competition.eventcodeId"
                  :competition="item.competition"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-4">
              <v-col cols="5">
                <b>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.CompetitionLevel.label",
                      "Competition level"
                    )
                  }}
                </b>
              </v-col>
              <v-col class="text-right text-secondary" cols="7">
                {{ get(item.competition, "competitionLevel.name", "") }}
              </v-col>
            </v-row>
            <v-row
              v-if="
                item.competition.cupSeasons &&
                item.competition.cupSeasons.length > 0
              "
              no-gutters
              class="mb-4"
            >
              <v-col cols="5">
                {{
                  $t(
                    "people:PersonProfile.CompetitionResultsSection.Cup.label",
                    "Cup"
                  )
                }}
              </v-col>
              <v-col class="text-right" cols="7">
                <AppShowCupSeasons
                  v-if="
                    item.competition.cupSeasons &&
                    item.competition.cupSeasons.length > 0
                  "
                  :cup-seasons="item.competition.cupSeasons"
                  class="text-secondary"
                  variant="text"
                />
                <div>
                  <AppShowCompetitionGrandPrix
                    :competition="item.competition"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row justify="center">
            <v-col cols="12" md="3">
              <div v-if="item.competition.event.discipline.name == 'driving'">
                <div>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.Grooms.label",
                      "Groom(s)"
                    )
                  }}: <AppShowDrivingGrooms :registration="item.registration" />
                </div>
                <div>
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.CarriageNr.label",
                      "Carriage nr"
                    )
                  }}: {{ item.registration.carriageNumber }}
                </div>
                <div v-if="item.registration.drivingCarriageWidth">
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.CarriageWidth.label",
                      "Carriage width"
                    )
                  }}:
                  {{ item.registration.drivingCarriageWidth }}
                </div>
              </div>
              <div
                v-else-if="item.competition.event.discipline.name == 'vaulting'"
              >
                <div>
                  <b>
                    {{
                      $t(
                        "people:PersonProfile.CompetitionResultsSection.Team.label",
                        "Team"
                      )
                    }}
                  </b>
                  : {{ item.registration.teamName }}
                </div>
                <br />
                <v-row no-gutters>
                  <v-col>
                    <b>
                      {{
                        $t(
                          "people:PersonProfile.CompetitionResultsSection.Athletes.label",
                          "Athletes"
                        )
                      }}
                    </b>
                    <AppShowPeopleList
                      :people="item.registration.athletes"
                      show-name-with-identifiers
                    />
                  </v-col>
                  <v-col v-if="item.registration.vaultingLungerPerson">
                    <b>
                      {{
                        $t(
                          "people:PersonProfile.CompetitionResultsSection.Lunger.label",
                          "Lunger"
                        )
                      }}
                    </b>
                    <AppShowPeopleList
                      :people="[item.registration.vaultingLungerPerson]"
                      show-name-only
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <template v-if="resultsIsVisible">
                <AppShowLongResults
                  v-if="showLongResults"
                  :result="item"
                  no-theme
                  :discipline-name="item.competition.event.discipline.name"
                  :competition="item.competition"
                />
                <div v-else class="text-center">
                  <AppShowResultPreview class="text-center" :result="item" />
                </div>
              </template>
            </v-col>
            <v-col cols="12" md="3" class="award-prize">
              <template v-if="showPersonCompetitionAward(item, personId)">
                <div v-if="item.prizeMoneyCents">
                  <div class="expanded-title mb-1">
                    {{
                      $t(
                        "people:PersonProfile.CompetitionResultsSection.Award.label",
                        "Award"
                      )
                    }}
                  </div>
                  {{
                    masterCurrency(item.prizeMoneyCents, { onlySymbol: true })
                  }}
                </div>
                <div v-else-if="item.isPlaced">
                  {{
                    $t(
                      "people:PersonProfile.CompetitionResultsSection.Award.label",
                      "Award"
                    )
                  }}
                  <v-icon>$iconRosette</v-icon>
                </div>
              </template>

              <ul class="my-3" style="padding-left: 0; list-style: none">
                <li v-for="point in displayPoints(item)" :key="point.id">
                  {{ get(point.chartRule, "chart.name", "?") }}:
                  {{ point.finalValue }}
                </li>
              </ul>

              <div
                v-if="
                  get(profilePerson, 'personClubRegion.name') &&
                  item.competition.event.discipline.name != 'vaulting'
                "
              >
                {{ $t("common:common.results.clubRegion.column") }}<br />
                <AppShowOrganisationName
                  :organisation="profilePerson.personClubOrganisationId"
                />
                <br />
                {{ get(profilePerson, "personClubRegion.name") }}

                <div v-if="activeRegistrationQualification">
                  <div class="mt-5">
                    {{
                      $t(
                        "people:PersonProfile.CompetitionResultsSection.qualifyingResult.text"
                      )
                    }}<template v-if="item.satisfiesQualification">
                      <span :aria-label="$t('common:yes.label')">
                        <v-icon color="green" size="small" class="ml-2"
                          >$iconCheck</v-icon
                        ></span
                      > </template
                    ><template v-else> - </template>
                  </div>
                  <div v-if="item.unqualifiesQualification" class="mt-2">
                    {{
                      $t(
                        "people:PersonProfile.CompetitionResultsSection.unqualifyingResult.text"
                      )
                    }}
                    <UnqualifiedBadge />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </td>
    </template>
  </tr>
</template>
<script>
import gql from "fraql";
import { get } from "lodash-es";
import { useCurrency } from "@composables/masterdata/config";
import { useQualificationHelper } from "@composables/masterdata/qualifications/qualifications";
import AppShowDifficultyLevel from "@AppShows/AppShowDifficultyLevel.vue";
import AppShowLongResults from "@AppShows/event/AppShowLongResults.vue";
import AppShowPeopleList from "@AppShows/person/AppShowPeopleList.vue";
import AppShowRegistrationHorses from "@AppShows/horse/AppShowRegistrationHorses.vue";
import AppShowResultPreview from "@AppShows/AppShowResultPreview.vue";
import AppShowCountry from "@AppShows/AppShowCountry.vue";
import AppShowOrganisationName from "@AppShows/organisation/AppShowOrganisationName.vue";
import AppShowCompetitionGrandPrix from "@AppShows/event/AppShowCompetitionGrandPrix.vue";
import AppShowEventcode from "@AppShows/event/AppShowEventcode.vue";
import { showPersonCompetitionAward } from "@/components/person/showPersonCompetitionAward";
import AppShowDrivingGrooms from "@AppShows/event/AppShowDrivingGrooms.vue";
import AppShowSection from "@AppShows/event/AppShowSection.vue";
import UnqualifiedBadge from "./qualifications/UnqualifiedBadge.vue";
import AppShowCupSeasons from "@AppShows/event/AppShowCupSeasons.vue";

export default {
  name: "AppCompetitionResultExpanded",
  components: {
    AppShowDifficultyLevel,
    AppShowLongResults,
    AppShowPeopleList,
    AppShowResultPreview,
    AppShowCountry,
    AppShowRegistrationHorses,
    AppShowOrganisationName,
    AppShowCompetitionGrandPrix,
    AppShowEventcode,
    AppShowDrivingGrooms,
    AppShowSection,
    UnqualifiedBadge,
    AppShowCupSeasons
  },
  props: {
    item: { type: Object, required: true },
    profile: { type: String, required: true },
    personId: { type: String, default: null },
    horseId: { type: String, default: null }
  },
  setup() {
    const { masterQualifications } = useQualificationHelper();
    return {
      masterQualifications,
      get,
      ...useCurrency(),
      showPersonCompetitionAward
    };
  },
  computed: {
    resultsIsVisible() {
      if (this.item.competition.event.discipline.codename == "endurance")
        return true;
      return !this.item.outsideOfCompetition;
    },
    showLongResults() {
      return !["showjumping", "icelandic", "mountedgames"].includes(
        this.item.competition.event.discipline.name
      );
    },
    profilePerson() {
      if (this.personId) {
        return this.item.registration.registrationPeople.find(
          x => x.personId == this.personId
        );
      }
      return false;
    },
    activeRegistrationQualification() {
      return this.masterQualifications.some(x => x.category == "REGISTRATION");
    }
  },
  methods: {
    displayPoints(item) {
      if (this.personId) {
        return item.points.filter(point => {
          return point.chartRule.chart.showPointsInAthleteResults;
        });
      }
      if (this.horseId) {
        return item.points.filter(point => {
          return point.chartRule.chart.showPointsInHorseResults;
        });
      }
    }
  },
  fragments: {
    pointFields: gql`
      fragment _ on Point {
        id
        finalValue
      }
    `,
    athleteChart: gql`
      fragment _ on Chart {
        showPointsInAthleteResults
      }
    `,
    horseChart: gql`
      fragment _ on Chart {
        showPointsInHorseResults
      }
    `,
    competition: gql`
      fragment _ on Competition {
        ${AppShowEventcode.fragments.competitionFields}
        ${AppShowLongResults.fragments.competition}
        ${AppShowDifficultyLevel.fragments.difficultyLevel}
        ${AppShowCompetitionGrandPrix.fragments.grandPrix}
        cupSeasons {
          id
          ${AppShowCupSeasons.fragments.cupSeasonFields}
        }
        event {
          disciplineId
          discipline @client {
            id
            name
            codename
          }
          countryId
          country @client {
            id
            name
          }
          regionId
          region @client {
            id
            name
          }
        }
      }
    `,
    registrationFields: gql`
      fragment _ on Registration {
        ${AppShowDrivingGrooms.fragments.registrationFields}
        registrationPeople {
          id
          personId
          personClubOrganisationId
          personClubOrganisation {
            id
            name
            shortName
          }
          personClubRegionId
          personClubRegion @client {
            id
            name
          }
        }
      }
    `,
    resultFields: gql`
      fragment _ on Result {
        ${AppShowLongResults.fragments.resultFields}
        satisfiesQualification
        unqualifiesQualification
      }
    `
  }
};
</script>
